.root {
  position: relative;
  display: inline-block;
}

.trigger {
  width: 34px;
  height: 34px;
  padding: 0;
  display: grid;
  place-items: center;
  border-radius: 50%;
  border: 1px solid var(--line);
  background: color-mix(in srgb, var(--surface) 82%, transparent);
  background-image: none;
  backdrop-filter: blur(6px);
  color: var(--muted);
  opacity: 0.62;
  transition:
    opacity 0.2s ease,
    transform 0.15s ease;
}

.trigger:hover,
.trigger[aria-expanded='true'] {
  opacity: 1;
  transform: scale(1.06);
}

.trigger[data-has='true'] {
  opacity: 1;
  border-color: var(--accent);
  box-shadow: 0 0 12px var(--card-glow);
}

.trigger svg,
.add svg {
  width: 18px;
  height: 18px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.emoji {
  font-size: 18px;
  line-height: 1;
}

.strip {
  position: absolute;
  right: 0;
  bottom: calc(100% + 8px);
  z-index: 20;
  display: flex;
  gap: 2px;
  padding: 4px;
  border-radius: 999px;
  background: var(--surface);
  border: 1px solid var(--accent);
  box-shadow: 0 8px 28px var(--card-glow);
}

.down {
  bottom: auto;
  top: calc(100% + 8px);
}

.center {
  right: auto;
  left: 50%;
  translate: -50% 0;
}

.pick {
  width: 38px;
  height: 38px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: none;
  background-image: none;
  font-size: 23px;
  line-height: 1;
  animation: rise 0.28s both;
  transition:
    transform 0.15s ease,
    background 0.15s ease;
}

.pick:nth-child(2) {
  animation-delay: 0.03s;
}
.pick:nth-child(3) {
  animation-delay: 0.06s;
}
.pick:nth-child(4) {
  animation-delay: 0.09s;
}
.pick:nth-child(5) {
  animation-delay: 0.12s;
}

.pick:hover {
  transform: scale(1.28) translateY(-3px);
}

.pick[aria-checked='true'] {
  background: color-mix(in srgb, var(--accent) 22%, transparent);
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.6);
  }
}

.msg {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
}

.msgEnd {
  align-items: flex-end;
}

.chips {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0 8px;
  height: 24px;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: var(--surface);
  background-image: none;
  font-size: 14px;
  line-height: 1;
  color: var(--text);
}

.chip[data-mine='true'] {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 16%, var(--surface));
}

.chip:disabled {
  opacity: 1;
  cursor: default;
}

.chip small {
  font-size: 11px;
  color: var(--muted);
}

.add {
  position: absolute;
  top: 8px;
  right: -32px;
  width: 26px;
  height: 26px;
  padding: 0;
  display: grid;
  place-items: center;
  border-radius: 50%;
  border: 1px solid var(--line);
  background: var(--surface);
  background-image: none;
  color: var(--muted);
  opacity: 0;
  transition: opacity 0.15s ease;
}

.msgEnd .add {
  right: auto;
  left: -32px;
}

.add svg {
  width: 15px;
  height: 15px;
}

.msg:hover .add,
.add:focus-visible,
.add[aria-expanded='true'] {
  opacity: 0.8;
}

@media (hover: none) {
  .add {
    display: none;
  }
}

.pop {
  position: absolute;
  left: 0;
  bottom: calc(100% - 4px);
  z-index: 20;
}

.popEnd {
  left: auto;
  right: 0;
}

.pop .strip {
  position: static;
}

@media (prefers-reduced-motion: reduce) {
  .pick {
    animation: none;
    transition: none;
  }

  .trigger {
    transition: none;
  }
}

.inline {
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.inline .add {
  position: static;
  display: grid;
  opacity: 0.55;
}

.inline .pop {
  bottom: calc(100% + 2px);
}
